<template>
  <div class="sf-graph-values-list">
    <div class="sf-pad-h-3 sf-pad-v-2 sf-layer-border-bottom">
      <div class="sf-level sf-level-between sf-below-2">
        <div class="sf-font-l sf-title">
          {{ I18n.t('js.report_graph.edit.graph_values.title') }}
        </div>

        <SfButtonDs
          variant="secondary"
          :disabled="readOnly"
          icon-before="plus"
          data-walkthrough-id="chart-add-new-series"
          @click="addGraphValue"
        >
          {{ I18n.t('js.report_graph.edit.graph_values.add_value') }}
        </SfButtonDs>
      </div>

      <div v-show="hasErrors">
        <div class="sf-alert sf-alert-danger sf-pad-1 sf-level-vertical">
          <div class="sf-level-item">
            {{ I18n.t('simple_form.error_notification.default_message') }}
          </div>
        </div>
      </div>
    </div>

    <div class="sf-charteditor-left-content sf-layer-border-bottom">
      <Draggable
        :model-value="activeGraphValues"
        class="sf-pad-3 sf-graph-values-wrapper"
        :disabled="readOnly"
        handle=".drag-handle"
        data-walkthrough-id="chart-series-form"
        item-key="key"
        @update:model-value="handleGraphListUpdate"
      >
        <template #item="{ element }">
          <GraphValue
            :id="`graph-value-${element.key}`"
            :value="element"
            :delete-graph-value="deleteGraphValue"
          />
        </template>
      </Draggable>
    </div>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import { nextTick } from 'vue'
import { mapState, mapActions, mapGetters } from 'vuex'

import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'

import GraphValue from './graph-value.vue'

const DEFAULT_SERIES_TYPE = 'line'
const DEFAULT_RELATIVE = 'PTD'

export default {
  components: {
    Draggable,
    GraphValue,
    SfButtonDs,
  },

  computed: {
    ...mapState(['graphValues', 'readOnly']),
    ...mapGetters(['graphValuesErrors']),
    activeGraphValues() {
      return this.graphValues
        .filter((value) => !value._destroy)
        .sort((a, b) => a.position - b.position)
    },
    hasErrors() {
      return this.graphValuesErrors.length > 0
    },
  },

  methods: {
    ...mapActions(['setGraphValues']),

    addGraphValue() {
      if (this.readOnly) {
        return
      }
      const newKey =
        Math.max(0, ...this.graphValues.map((value) => value.key)) + 1

      this.graphValues.map((graphValue) => (graphValue.collapsed = true))

      this.graphValues.push({
        key: newKey,
        name: {},
        position: this.graphValues.length + 1,
        seriesType: DEFAULT_SERIES_TYPE,
        relative: DEFAULT_RELATIVE,
        budget: false,
        valueType: '',
        delta: 0,
        collapsed: false,
      })

      this.setGraphValues({ graphValues: this.graphValues })

      nextTick(() => {
        document.getElementById(`graph-value-${newKey}`).scrollIntoView(true)
      })
    },

    handleGraphListUpdate(graphValues) {
      if (this.readOnly) {
        return
      }

      const activeReindexed = graphValues
        .filter((value) => !value._destroy)
        .map((value, index) => ({ ...value, position: index }))

      const destroyedFromIncoming = graphValues.filter(
        (value) => value._destroy
      )
      const destroyedFromState = this.graphValues.filter(
        (value) =>
          value._destroy &&
          !destroyedFromIncoming.some((entry) => entry.key === value.key)
      )

      this.setGraphValues({
        graphValues: [
          ...activeReindexed,
          ...destroyedFromIncoming,
          ...destroyedFromState,
        ],
      })
    },

    deleteGraphValue(key) {
      this.handleGraphListUpdate(
        this.graphValues.map((value) =>
          value.key === key ? { ...value, _destroy: true } : value
        )
      )
    },
  },
}
</script>
